import React, { useState, useEffect } from 'react';
import { logPageView } from './services/analytics';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CalendarProvider } from './contexts/CalendarContext';
import { GoalProvider } from './contexts/GoalContext';
import { Last10Provider } from './contexts/Last10Context';
import { NotificationProvider } from './contexts/NotificationContext';
import Header from './components/Layout/Header';
import Navigation from './components/Layout/Navigation';
import CalendarView from './components/Calendar/CalendarView';
import TaskList from './components/Task/TaskList';
import GoalsList from './components/Goals/GoalsList';
import InstallPrompt from './components/Common/InstallPrompt';

const VIEW_META = {
    calendar: { path: '/calendar', title: 'Calendar View' },
    list: { path: '/tasks', title: 'Task List' },
    goals: { path: '/goals', title: 'Goals' },
};

function AppContent() {
    const [currentView, setCurrentView] = useState('calendar'); // 'calendar', 'list', or 'goals'

    // Track page views whenever the active view changes
    useEffect(() => {
        const meta = VIEW_META[currentView] || { path: `/${currentView}`, title: currentView };
        logPageView(meta.path, meta.title);
    }, [currentView]);

    // Always show the main app - authentication is handled in the header
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
            <Header />
            <Navigation currentView={currentView} onViewChange={setCurrentView} />

            <main className="container mx-auto px-4 py-6 max-w-7xl">
                {currentView === 'calendar' ? (
                    <CalendarView />
                ) : currentView === 'list' ? (
                    <TaskList />
                ) : (
                    <GoalsList />
                )}
            </main>

            {/* PWA Install Prompt */}
            <InstallPrompt />
        </div>
    );
}

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <NotificationProvider>
                    <CalendarProvider>
                        <GoalProvider>
                            <Last10Provider>
                                <AppContent />
                            </Last10Provider>
                        </GoalProvider>
                    </CalendarProvider>
                </NotificationProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;